import hitungIuran from './hitung-iuran'
import register from './register'
import verifyKTP from './verify-ktp'
import prosesKodeIuran from './proses-kode-iuran'

export {
  hitungIuran, register, verifyKTP, prosesKodeIuran
}



// WEBPACK FOOTER //
// ./src/bpjs-api/api.js